export const StepHeader = ({ number = "", children = "", className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="text-4xl md:text-6xl text-primary-hover">{number}</div>
      <div className="text-xl md:text-3xl">{children}</div>
    </div>
  );
};
